import Hammer from 'hammerjs';
import Pubsub from 'pubsub-js';

class NavItem {
  constructor(element) {
    this.clicked = false;
    this.element = $(element);
    this.hammer = new Hammer(this.element.get(0));
    this.parent = this.element.parent();

    // pubsub listener to clear our 'clicked' status if another
    // parent navigation item is clicked.
    this.token = Pubsub.subscribe('navigation.tap', (message, data) => {
      if (data !== this.parent.attr('id')) {
        this.clicked = false;
      }
    });

    this.hammer.on('tap', this.tapEventHandler.bind(this));
  }

  tapEventHandler(e) {
    if (this.clicked === false) {
      e.preventDefault();

      Pubsub.publish('navigation.tap', this.parent.attr('id'));

      this.clicked = true;

      return false;
    }
  }
}

export default NavItem;


// WEBPACK FOOTER //
// ./scripts/components/NavItem.js